import {KilnConfigApp} from '@hconnect/kilnfeature/src/App'

import {PageLayout} from '@settings/modules/common/components'

export const KilnConfigPage = () => {
  return (
    <PageLayout>
      <KilnConfigApp />
    </PageLayout>
  )
}
